import { Book } from '@cna/projects/ak-jura/shared/interfaces';
import { UUID } from '@cna/shared/generic-types';

/**
 * Represents a template of a subset of chapters from an arbitrary number of books used in modules
 */
export interface ModuleDocumentTemplate
    extends Omit<Book, 'title' | 'documentRef'> {
    /**
     * Universally unique identifier
     */
    id: UUID;
    /**
     * Universally unique identifier of a corresponding module
     */
    moduleId: UUID;
    /**
     * Universally unique identifier of the corresponding document for this template
     */
    documentId?: UUID;
}

export function isModuleDocumentTemplate(value: unknown): value is ModuleDocumentTemplate {
    return (
        typeof value === 'object' &&
        value !== null &&
        'chapters' in value &&
        Array.isArray(value['chapters']) &&
        'moduleId' in value
    );
}
